import {STORE_EXTRA_INITIALIZE} from "../../../constants/ExtraConstants";
import {GeneralAction, UserExtraPayload} from "../../../@types/actions";

export const StoreSettingAction = (data: UserExtraPayload): GeneralAction<UserExtraPayload> => ({
    type: STORE_EXTRA_INITIALIZE,
    payload: data
});
